module.exports = __webpack_public_path__ + "img/loadding.983eb169.svg";